import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import './ContactUsSkeleton.scss';

function skeletonContactUsTopBanner() {
  return (
    <div className="contactUsTopBannerSkeleton">
      <Skeleton className="skeletonView" />
    </div>
  );
};

function skeletonheadAndBreadCrum() {
  return (
    <div className="breadcrumSkeleton">
      <Skeleton width={200} height={30} />
      <Skeleton width={300} height={40} />
    </div>
  );
};

function skeletonContactInfo() {
  return (
    <div className="contactInfoSkeleton">
      <div className="infoBox">
        <Skeleton width={30} height={30} className='skeleton' />
        <Skeleton height={30} width={200} />
      </div>
      <div className="infoBox">
        <Skeleton width={30} height={30} className='skeleton' />
        <Skeleton count={3} height={30} width={200} />
      </div>
      <div className="infoBox">
        <Skeleton width={30} height={30} className='skeleton' />
        <Skeleton height={30} width={200} />
      </div>
    </div>
  );
};

function skeletonContactUSForm() {
  return (
    <div className="contactUsForm">
      <Skeleton width={200} height={30} />
      <Skeleton count={3} width={300} height={20} />
      <Skeleton width="100%" height={60} />
      <Skeleton width="100%" height={60} />
      <Skeleton width="100%" height={60} />
      <Skeleton width="100%" height={60} />
      <Skeleton width="100%" height={60} />
      <Skeleton width="100%" height={60} className='buttonSkeleton' />
    </div>
  );
};

export default function ContactUsSkeleton() {
  return (
    <div className='ContactUsSkeletonWrapper'>
      {skeletonContactUsTopBanner()}
      {skeletonheadAndBreadCrum()}
      <div className="contactBox">
        <div className="boxSkeletonUI">
          <Skeleton width={200} height={30} className='mt-4' />
          <div className="contactUsbox">
            {skeletonContactInfo()}
          </div>
          <div className="formBoxUI">
            {skeletonContactInfo()}
          </div>
        </div>

        <div className="contactUsFormSkeletonUI">{skeletonContactUSForm()}</div>
      </div>
    </div>
  );
};